import styled from "styled-components";

export const CertificateFormStyled = styled.div`
  border-radius: 1rem;
  padding: 1.5rem 1rem;
  min-width: 500px;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  .form_section {
    margin-bottom: 60px;
    .form_title {
      margin-bottom: 1.5rem;
      text-align: left;
      color: ${({ theme }) => theme.COLORS.BLACK_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S20};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
    .input_row {
      margin-bottom: 20px;
      display: flex;
      width: 100%;
      .f_left_col {
        width: 20%;
        display: flex;
        align-items: center;
      }
      .f_right_col {
        width: 40%;
        .dl_simple_btn {
          width: 156px;
        }
      }
    }
    .input_wrap {
      margin-bottom: 1rem;
    }
    .btn_clear_date {
      margin-top: 6px;
      padding: 0;
      background: transparent;
      border: none;
      cursor: pointer;
      text-decoration: underline;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_LIGHT};
    }

    .certificate_canva {
      margin-bottom: 20px;
      display: ${({ isShowCanva }) => (isShowCanva ? "block" : "none")};
      /* template จริงกว้าง 3508px ถ้าไม่จำกัดไว้ canvas จะกางตามขนาดจริงจนล้นจอ
         ย่อแค่ "ขนาดที่แสดง" เท่านั้น ไม่กระทบไฟล์ที่ได้
         เพราะ toDataURL() อ่านจาก canvas.width/height ไม่ใช่ค่า CSS */
      max-width: 100%;
      height: auto;
      border: 1px solid ${({ theme }) => theme.COLORS.GRAY_11};
    }
    .btn_download {
      width: 182px;
    }
  }

  /* จัดเรียงเหมือน .qrcode_row ในหน้า Activity จะได้หน้าตาตรงกัน */
  .cf_qrcode_row {
    display: flex;
    flex-wrap: wrap;
    column-gap: 2rem;
    row-gap: 2rem;
  }

  .cf_action_row {
    margin-top: 1.5rem;
    display: flex;
    justify-content: right;
    column-gap: 1rem;
    .cf_action_item {
      width: 100%;
      max-width: 160px;
    }
  }
`;
